"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _CartProvider = require("./CartProvider");
var _useMinicart2 = require("../common/useMinicart");
var _MessageHandlerProvider = require("../common/MessageHandlerProvider");
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _useAnalytics4AndCommerceTags = _interopRequireDefault(require("../common/useAnalytics4AndCommerceTags"));
var _useSalesmanago = _interopRequireDefault(require("./useSalesmanago"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function useCartModifier(props) {
  var product = props.product,
    categoryName = props.categoryName,
    listId = props.listId,
    listType = props.listType,
    listPosition = props.listPosition,
    isProductPageHit = props.isProductPageHit;
  var _useState = (0, _react.useState)(false),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useCart = (0, _CartProvider.useCart)(),
    addProduct = _useCart.addProduct,
    removeItem = _useCart.removeItem,
    updateItemQuantity = _useCart.updateItemQuantity,
    cart = _useCart.cart;
  var handleSalesmanagoEvent = (0, _useSalesmanago["default"])();
  var _useMinicart = (0, _useMinicart2.useMinicart)(),
    setMinicartLoading = _useMinicart.setMinicartLoading,
    addNewItemToMinicart = _useMinicart.addNewItemToMinicart,
    removeItemFromMinicart = _useMinicart.removeItemFromMinicart,
    updateMinicartContent = _useMinicart.updateMinicartContent,
    setMinicartContentFromStorage = _useMinicart.setMinicartContentFromStorage,
    minicartState = _useMinicart.minicartState,
    updateTemporaryData = _useMinicart.updateTemporaryData;
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var _useAnalyticsAndComme = (0, _useAnalytics4AndCommerceTags["default"])(),
    productAddedToCart = _useAnalyticsAndComme.productAddedToCart,
    productRemovedFromCart = _useAnalyticsAndComme.productRemovedFromCart;
  var translations = {
    productAddedToCart: (0, _langLibrary["default"])("Product was added to cart")
  };
  var qtyUpdateDifference = function qtyUpdateDifference(quantity, changedProduct) {
    return quantity - minicartState.minicartContent.find(function (stateProduct) {
      return stateProduct.sku === changedProduct.sku;
    }).quantity;
  };
  var add = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(quantity) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              setMinicartLoading(true);
              updateTemporaryData(quantity, product);
              _context.prev = 3;
              _context.next = 6;
              return addProduct(product, quantity, isProductPageHit);
            case 6:
              setLoading(false);
              setMinicartLoading(false);
              updateTemporaryData();
              addNewItemToMinicart(product, quantity);
              handleMessage(translations.productAddedToCart, false, false);
              productAddedToCart(product, quantity, categoryName, cart === null || cart === void 0 ? void 0 : cart.currency, listId, listType, listPosition);
              handleSalesmanagoEvent("CART", {
                products: [product.sku],
                details: [translations.productAddedToCart],
                value: product.price.special ? product.price.special : product.price.regular
              });
              _context.next = 21;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](3);
              setLoading(false);
              setMinicartLoading(false);
              updateTemporaryData();
              handleMessage(_context.t0);
            case 21:
              setMinicartContentFromStorage();
            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 15]]);
    }));
    return function add(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var update = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(quantity) {
      var qtyDifference;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              setMinicartLoading(true);
              qtyDifference = qtyUpdateDifference(quantity, product);
              updateTemporaryData(qtyDifference, product);
              _context2.prev = 4;
              _context2.next = 7;
              return updateItemQuantity(product.sku, quantity);
            case 7:
              setLoading(false);
              setMinicartLoading(false);
              updateTemporaryData();
              qtyDifference > 0 ? productAddedToCart(product, qtyDifference, categoryName) : productRemovedFromCart(product, categoryName, Math.abs(qtyDifference));
              updateMinicartContent(product.sku, quantity);
              handleSalesmanagoEvent("CART", {
                products: [product.sku],
                details: [translations.productUpdated, "Qty: " + quantity],
                value: product.price.special ? product.price.special : product.price.regular
              });
              _context2.next = 22;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](4);
              setLoading(false);
              setMinicartLoading(false);
              updateTemporaryData();
              handleMessage(_context2.t0);
              throw _context2.t0;
            case 22:
              setMinicartContentFromStorage();
            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 15]]);
    }));
    return function update(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var remove = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(productCategoryName, quantity) {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading(true);
              setMinicartLoading(true);
              removeItemFromMinicart(product.sku);
              _context3.prev = 3;
              _context3.next = 6;
              return removeItem(product.sku);
            case 6:
              setLoading(false);
              setMinicartLoading(false);
              productRemovedFromCart(product, productCategoryName, quantity);
              handleSalesmanagoEvent("CART", {
                products: [product.sku],
                details: [translations.productDeleted],
                value: product.price.special ? product.price.special : product.price.regular
              });
              _context3.next = 17;
              break;
            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](3);
              setLoading(false);
              setMinicartLoading(false);
              handleMessage(_context3.t0);
            case 17:
              setMinicartContentFromStorage();
            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 12]]);
    }));
    return function remove(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    loading: loading,
    add: add,
    remove: remove,
    update: update
  };
}
var _default = useCartModifier;
exports["default"] = _default;